import IsDocumentSafe from './IsDocumentSafe';

const convertMinutesToMilliseconds = minutes => minutes * 60 * 1000;

export const calculateExpiredDate = (expireInMinutes: number) => {
  const expireInSecondsFromEpoch = new Date().setTime(
    new Date().getTime() + convertMinutesToMilliseconds(expireInMinutes)
  );
  const expireDate = new Date(expireInSecondsFromEpoch);
  return expireDate ? `; expires=${expireDate.toUTCString()}` : '';
};

const Cookies = {
  get: (name: string) => {
    if (!IsDocumentSafe()) { return null; }
    const regexp = new RegExp(`(?:^${name}|; *${name})=(.*?)(?:;|$)`, 'g');
    const result = regexp.exec(document.cookie);
    return result === null ? null : result[1];
  },
  set: (name: string, value: string, expireInMinutes: number) => {
    if (!IsDocumentSafe()) { return; }
    const expires = calculateExpiredDate(expireInMinutes);
    document.cookie = `${name}=${value}${expires}; path=/`;
  }
};

export default Cookies;
